<div>
  <table *ngIf="displayedColumns.length" mat-table [dataSource]="list" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <ng-container *ngFor="let item of displayedColumns" matColumnDef="{{item}}">
      <th mat-header-cell *matHeaderCellDef> {{settings.translateEnglish(item, translation)}} </th>
      <td mat-cell *matCellDef="let element"> {{element[item]}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer" (click)="clickedRow(row)"></tr>

  </table>
  <div *ngIf="!displayedColumns.length" style="align-content: center; text-align: center; margin-top: 20px">
    <span style="text-align: center">
      موردی یافت نشده است
    </span>
  </div>
</div>
